import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const FormacijniMateriali = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-3  ">
        <div className="flex flex-col justify-center md:flex-row">
          <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414] ">Формаційні матеріали</h1>
        </div>
      </div>
    </>
  );
};

export default FormacijniMateriali;
